import React, { SVGProps } from 'react';
import * as Icons from '../assets/icon';

// Tự động lấy danh sách tên icon từ các export trong @assets/icon/index.ts
export type IconName = keyof typeof Icons;

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  className?: string;
  style?: React.CSSProperties;
}

export const Icon = ({ name, className = '', style, ...props }: IconProps) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in @assets/icon`);
    return null;
  }

  return (
    <div 
      className={`icon-container ${className}`} 
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', ...style }}
    >
      <IconComponent {...props} />
    </div>
  );
};